import React from 'react';
import { ImageListing } from 'iovisit-theme/components';

const SliderImage = (props) => {
  return <ImageListing {...props} />;
};

export default SliderImage;
